<template>
  <div class="banner">
    <div class="columns">
      <div class="column has-text-centered-mobile">
        <a href="http://www.catie.ac.cr" target="_blank" rel="noopener"
          ><img
            v-if="userPrefersDark"
            alt="CATIE"
            class="banner__logo"
            src="@/assets/images/shared/catie-fff.svg"/><img
            v-else
            alt="CATIE"
            class="banner__logo"
            src="@/assets/images/shared/catie.svg"
        /></a>
        <div class="subtitle">
          {{
            $t("footer.freeSoftware", {
              programName: $t("commons.programName"),
              programVersionNumber: "6.0.0",
              catie: $t("commons.catie")
            })
          }}
        </div>
      </div>
      <div class="column has-text-centered-mobile has-text-right">
        <a
          href="https://www.facebook.com/pages/CATIE-Centro-Agron%C3%B3mico-Tropical-de-Investigaci%C3%B3n-y-Ense%C3%B1anza/116155101806729?ref=hl%20"
          target="_blank"
          rel="noopener"
          class="banner__social banner__social--facebook"
          ><img
            alt="CATIE facebook"
            class="social__logo"
            src="@/assets/images/shared/facebook.svg"
        /></a>
        <a
          href="https://twitter.com/CATIEOficial"
          target="_blank"
          rel="noopener"
          class="banner__social banner__social--twitter"
          ><img
            alt="CATIE twitter"
            class="social__logo"
            src="@/assets/images/shared/twitter.svg"
        /></a>
        <a
          href="https://cr.linkedin.com/in/catie-oficial-754625a9/en"
          target="_blank"
          rel="noopener"
          class="banner__social banner__social--linkedin"
          ><img
            alt="CATIE linkedin"
            class="social__logo"
            src="@/assets/images/shared/linkedin.svg"
        /></a>
        <a
          href="https://www.youtube.com/user/CATIEcanal"
          target="_blank"
          rel="noopener"
          class="banner__social banner__social--youtube"
          ><img
            alt="CATIE youtube"
            class="social__logo"
            src="@/assets/images/shared/youtube.svg"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
const userPrefersDark =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export default {
  data() {
    return {
      userPrefersDark
    };
  }
};
</script>
